export default "__VITE_ASSET__BeXkhUfD__"